import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import PlantillaFormSections from "./PlantillaFormSections.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fileurl: ""
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }


    SetData(data) {
        this.setState({
            fileurl: data.url
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.plantillas.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Plantilla"}
                buttonTitle={"Ver Plantilla"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog ui-modal-md"}
                onGotData={(data) => this.SetData(data)}>
                <div className="ui-form">
                    <PlantillaFormSections
                        disabled={true}
                        fileUrl={this.state.fileurl}
                        showUpload={false} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Proyectos_Plantillas/Detail.js